module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "row col-md-12"
  }, [_c('div', {
    class: {
      'col-md-10': _vm.trabalho.trabalho_completo != '', 'col-md-12': _vm.trabalho.trabalho_completo == ''
    }
  }, [_c('div', {
    staticClass: "trabalho-titulo-autores"
  }, [_c('div', {
    staticClass: "trabalho-id-wrapper"
  }, [_c('div', {
    staticClass: "rotate"
  }, [_c('div', {
    staticClass: "trabalho-id"
  }, [_vm._v(_vm._s(_vm.trabalho.id))])])]), _vm._v(" "), _c('div', {
    staticClass: "trabalho-titulo-autores-content"
  }, [_c('div', {
    staticClass: "trabalho-titulo"
  }, [_vm._v(_vm._s(_vm.trabalho.titulo))]), _vm._v(" "), _c('div', {
    staticClass: "trabalho-autores"
  }, [_vm._l((_vm.trabalho.todos_autores), function(a, index) {
    return [(index != 0) ? _c('span', [_vm._v(" ; ")]) : _vm._e(), _vm._v(" "), _c('router-link', {
      staticClass: "trabalho-autor",
      attrs: {
        "to": '/autor/' + a.id
      }
    }, [_vm._v(_vm._s(a.nome)), _c('sup', [_vm._v(_vm._s(_vm.trabalho.instituicoes.indexOf(a.instituicao) + 1))])])]
  })], 2)])])]), _vm._v(" "), (_vm.trabalho.trabalho_completo != '') ? _c('div', {
    staticClass: "col-md-2"
  }, [_c('div', {
    staticClass: "text-right download-wrapper"
  }, [_c('div', [_c('a', {
    staticClass: "btn btn-primary btn-lg text-center",
    attrs: {
      "href": _vm.trabalho.trabalho_completo
    }
  }, [_c('i', {
    staticClass: "fa fa-download"
  }), _vm._v(" "), _c('br'), _vm._v("\n            " + _vm._s(_vm.$t('baixar_trabalho')) + "\n          ")])])])]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('div', {
    staticClass: "row-side-info"
  }, [_c('div', [_c('b', [_vm._v(_vm._s(_vm._f("capitalize")(_vm.$tc('instituicao', 2))))])]), _vm._v(" "), _vm._l((_vm.trabalho.instituicoes), function(i, index) {
    return _c('div', [_c('router-link', {
      attrs: {
        "to": {
          name: 'trabalhos',
          params: {
            pesquisa: i
          }
        }
      }
    }, [_c('sup', [_vm._v(_vm._s(index + 1))]), _vm._v(_vm._s(i) + "\n          ")])], 1)
  })], 2), _vm._v(" "), _c('div', {
    staticClass: "row-side-info"
  }, [_c('div', [_c('b', [_vm._v(_vm._s(_vm._f("capitalize")(_vm.$tc('eixo', 2))))])]), _vm._v(" "), _c('div', [_c('router-link', {
    attrs: {
      "to": {
        name: 'trabalhos',
        params: {
          pesquisa: _vm.trabalho.eixo.nome
        }
      }
    }
  }, [_vm._v("\n            " + _vm._s(_vm.trabalho.eixo.nome) + "\n          ")])], 1)]), _vm._v(" "), (_vm.trabalho.palavras_chaves.length) ? _c('div', {
    staticClass: "row-side-info"
  }, [_c('div', [_c('b', [_vm._v(_vm._s(_vm._f("capitalize")(_vm.$tc('palavra_chave', 2))))])]), _vm._v(" "), _vm._l((_vm.trabalho.palavras_chaves), function(p, index) {
    return _c('div', [_c('router-link', {
      attrs: {
        "to": {
          name: 'trabalhos',
          params: {
            pesquisa: p.palavra_chave
          }
        }
      }
    }, [_c('sup', [_vm._v(_vm._s(index + 1))]), _vm._v(_vm._s(p.palavra_chave) + "\n          ")])], 1)
  })], 2) : _vm._e()]), _vm._v(" "), (_vm.trabalho.resumo != '') ? [_c('div', {
    staticClass: "col-md-12 resumo"
  }, [_c('b', [_vm._v(_vm._s(_vm._f("capitalize")(_vm.$tc('resumo', 1))) + ":")])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-12 resumo"
  }, _vm._l((_vm.trabalho.resumo_parsed.split('\n')), function(line) {
    return (line.trim() != '') ? _c('p', [_vm._v("\n          " + _vm._s(line) + "\n        ")]) : _vm._e()
  }))] : _vm._e()], 2)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-424e5632","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/anais/AnaisTrabalho.vue
// module id = 211
// module chunks = 0